import React, { Component } from 'react'
import { get } from 'lodash'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import Lightbox from 'react-images'
import queryString from 'query-string'

import styles from './img.styl'
import { isValidAuthCode, refreshBlobAccess } from '../../../redux/modules/auth'

@withRouter
@connect(({ auth }) => ({
  user: auth.user
}),
  { isValidAuthCode, refreshBlobAccess }
)
class Img extends Component {
  static propTypes = {
    src: PropTypes.string,
    ref: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    defaultWidth: PropTypes.number,
    defaultHeight: PropTypes.number,
    alt: PropTypes.string,
    location: PropTypes.object,
    user: PropTypes.object,
    withCode: PropTypes.bool,
    asGallery: PropTypes.bool,
    isValidAuthCode: PropTypes.func.isRequired,
    refreshBlobAccess: PropTypes.func.isRequired
  }

  static defaultProps = {
    defaultWidth: 500,
    width: '100%',
    height: 100,
    defaultHeight: 500,
    asGallery: false
  }

  state = {
    isOpen: false,
    isAuthCodeValid: false
  }

  async componentDidMount () {
    const { user, withCode } = this.props
    user && await this.refreshBlobAccess(get(user, 'blobAccessAuthorizationCode'))

    withCode && await this.refreshBlobAccess(this.getAuthenticationCode())
  }

  refreshBlobAccess = async authCode => {
    const { body: isValid } = await this.props.isValidAuthCode(authCode)
    if(!isValid.value){
      await this.props.refreshBlobAccess(authCode)
    }
    this.setState({ isAuthCodeValid: true })
  }

  getAuthenticationCode = () => {
    const query = queryString.parse(get(this.props, 'location.search'))
    return get(query, 'authorizationCode') || ''
  }

  handleOpenLightbox = () => {
    this.setState({
      isOpen: true
    })
  }

  handleCloseLightbox = () => {
    this.setState({
      isOpen: false
    })
  }

  render() {
    const {
      src,
      user,
      ref,
      width,
      height,
      defaultWidth,
      defaultHeight,
      alt,
      className,
      withCode,
      asGallery
    } = this.props
    const { isOpen } = this.state
    let suffix = ''
    let authorizationCode = ''

    if (!src) {
      return null
    }

    const defaultImageSize = `&r=${defaultWidth}x${defaultHeight}`
    const operator = src.includes('?') ? '&' : '?'

    if (withCode) {
      authorizationCode = this.getAuthenticationCode()
    }

    if (get(user, 'blobAccessAuthorizationCode')) {
      authorizationCode = user.blobAccessAuthorizationCode
    }

    suffix = `${operator}authorizationCode=${authorizationCode}${
      defaultImageSize
    }`

    return (
      <div>
        {!asGallery && (
          <img
            src={`${src}${suffix}`}
            ref={ref}
            width={width}
            height={height}
            className={className}
            alt={alt}
          />
        )}

        {asGallery && (
          <div onClick={this.handleOpenLightbox}>
            <div
              className={styles.image}
              style={{
                backgroundImage: `url('${src}${suffix}')`,
                maxHeight: height,
                height,
                width
              }}
            />
            <Lightbox
              images={[{ src: `${src}${suffix}` }]}
              isOpen={isOpen}
              onClose={this.handleCloseLightbox}
              showImageCount={false}
            />
          </div>
        )}
      </div>
    )
  }
}

export default Img
